import { render } from "./Subscriptions.vue?vue&type=template&id=f12f53f8&scoped=true"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"

import "./Subscriptions.vue?vue&type=style&index=0&id=f12f53f8&lang=scss&scoped=true"

import exportComponent from "/home/vestment25/upgrading/jarvis-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12f53f8"]])

export default __exports__